/**
 * Created by sung on 2017-02-07.
 */
import {Component, OnInit, Pipe, ViewChild, ViewChildren, AfterViewChecked, AfterContentInit, AfterViewInit, QueryList, Query} from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import {NgModule} from '@angular/core';
import {SelectItem} from 'primeng/primeng';
import {FormsModule} from "@angular/forms";
import { DataTableModule, SharedModule, ButtonModule,TabViewModule,PanelModule,PaginatorModule, DropdownModule, GMapModule ,InputMaskModule, InputTextModule} from 'primeng/primeng';
import {MamAdminService} from '../../service/mam_service.component';
import { Location } from '../../model/location';
import { Control_Gps } from '../../model/control_gps';
import { Control_Ap } from '../../model/control_ap';
import { BeaconArea } from '../../model/beaconarea';
import { ThirdPartyCompany } from '../../model/thirdpartycompany';
import { LocationDialogModule } from  '../../component/policyresource.dialog.component';
import {SearchModule} from "../../component/search.component";
import {ExDialogModule} from "../../component/dialog.component";

import { CustomGMapModule } from "../../component/gmap.component";
import {MainPipeMoudle} from "../../pipe/main.pipe";
//import { AgmCoreModule } from 'angular2-google-maps/core';

import {Logger, Options, Level } from "angular2-logger/core";
import {TranslatePipeMoudle} from "../../translate/translate.module.pipe";
import {TranslateServiceForm} from "../../translate/translate.service"; // ADD THIS
import * as glob from "../../service/global_url";
import {kyungnamIsTrue} from "../../service/global_url";

declare var google: any;

@Component({
selector: 'policy-resource',
templateUrl: 'policy_resource.html'

})
export class PolicyResourceComponent implements OnInit {

  google_map : any;

  @ViewChild('bsidMask') bsidMask : any;
  private location_list : Location[] = [];
  private control_gps_list : Control_Gps[] = [];
  private control_ap_list : Control_Ap[] = [];
  private control_beancon_list : BeaconArea[] = [];
  private company_list : ThirdPartyCompany[] = [];
  selectedCompany : ThirdPartyCompany;

  dateIsTrue : boolean;
  searchIsTrue : boolean;
  searchText: string;
  searchId : string;
  pageMax:number =10;
  totalRecord : number;
  dialogWidth : number = 600;
  ap_dialogWidth : number = 600;
  gps_dialogWidth : number =  800;
  searchIDs: SelectItem[];
  company_item : SelectItem[];

  title : string;

  location_ : Location ;
  beacon_ : BeaconArea;
  //-------------------- beacon ---------------
  beacon_name: string = '';
  beacon_uuid: string = '';
  beacon_major : number = 0;
  beacon_minor : number = 0;
  beacon_description : string = '';
  beacon_company : string = '';
  add_dlg_show : number = 0;
  selectBeacons : any[]=[];
//-------------------- location ---------------
  location_name : string = '';
  location_cellId : string = '';
  location_address : string= '';
  location_latitude : string = '';
  location_longitude : string = '';
  location_description  : string = '';
  selectLocations : any[]=[];
  location_show_type : string;
  location_show : boolean = false;
  //-------------------- ap ---------------
  ap_name : string = '';
  ap_bsid : string = '';
  ap_ssid : string = '';
  ap_auth : string = '';
  ap_pin  : string = '';
  ap_company : number = 1;
  ap_desc : string = '';
  selectAps : any[] =[];
  //-------------------- gps ---------------
  gps_name : string;
  gps_address : string;
  gps_desc : string;
  gps_locationgps : string;
  gps_company : string;
  selectGpses : any[]=[];
  gps_options: any;
  overlays: any[];
  create_gps :string;
  selectGps : any;
  gps_show_type : string = "add";
  gps_id : number;

  location_add_dlg_show : boolean =false;
  beacon_add_dlg_show : boolean = false;
  ap_add_dlg_show : boolean = false;
  gps_add_dlg_show : boolean = false;

  sDate : string
  eDate : string
  activeTabNumber:number = 0;

  gmap_show :boolean = false;

  gps_search : string;
  infoWindow : any;

  map : any;
  gps_data : string = "";
  translate : TranslateServiceForm;
  kyungnamIsTrue : boolean = glob.kyungnamIsTrue;
  ngOnInit() {
    if(kyungnamIsTrue){
      this.activeTabNumber = 2;
    }else{
      this.activeTabNumber = 0;
    }

    this.getLocationList(1,10, '','','');
    this.getCompanyList();

  }

  constructor(private  service:  MamAdminService, private logger : Logger, private _translate: TranslateServiceForm) {
    this.translate = _translate;
    this.searchIDs = [];
    this.searchIDs.push({label: '---------------', value: 'all'});
    this.searchIDs.push({label: this.translate.instant('LANG_LOC_locationid'), value: 'name'});
    this.searchIDs.push({label: this.translate.instant('LANG_LOC_address'), value: 'address'});
    this.searchIDs.push({label: this.translate.instant('LANG_LOC_latitude'), value: 'latitude'});
    this.searchIDs.push({label: this.translate.instant('LANG_LOC_longitude'), value: 'longitude'});
    this.searchIDs.push({label: 'Cell Id', value: 'cellId'});

    this.dateIsTrue = false;


  }

  getSearchModel(event){
    this.logger.debug("event : ",event);
    this.searchIsTrue = event.searchIsTrue;
    this.searchText = event.searchText;
    this.searchId = event.searchId;
    this.sDate = event.sDate;
    this.eDate = event.eDate;
    this.logger.debug(event.sDate);


    switch(this.activeTabNumber){
      case 0:
        this.getLocationList(1, this.pageMax, this.searchText, "true", this.searchId);
        break;
      case 1:
        this.getGpsList(1, this.pageMax, this.searchText, "true", this.searchId);
        break;
      case 2:
        this.getApList(1, this.pageMax, this.searchText, "true", this.searchId);
        break;
      case 3:
        this.getBeaconList(1, this.pageMax, this.searchText, "true", this.searchId);
        break;
    }

  }

  paginate(event) {
    this.pageMax = event.rows;
    if (this.searchIsTrue) {
      switch(this.activeTabNumber){
        case 0:
          this.getLocationList(event.page +1, event.rows, this.searchText, "true", this.searchId);
          break;
        case 1:
          this.getGpsList(event.page +1, event.rows, this.searchText, "true", this.searchId);
          break;
        case 2:
          this.getApList(event.page +1, event.rows, this.searchText, "true", this.searchId);
          break;
        case 3:
          this.getBeaconList(event.page +1, event.rows, this.searchText, "true", this.searchId);
          break;
      }

    } else {
      switch(this.activeTabNumber){
        case 0:
          this.getLocationList(event.page + 1,this.pageMax,"","","");
          break;
        case 1:
          this.getGpsList(event.page +1, event.rows,"","","");
          break;
        case 2:
          this.getApList(event.page +1, event.rows, "","","");
          break;
        case 3:
          this.getBeaconList(event.page +1, event.rows ,"","","");
          break;
      }

    }

  }


  onTabChange(event) {
    this.activeTabNumber = event.index;
    if(this.activeTabNumber == 0) {
      this.searchIDs = [];
      this.searchIDs.push({label: '---------------', value: 'all'});
      this.searchIDs.push({label: this.translate.instant('LANG_LOC_locationid'), value: 'name'});
      this.searchIDs.push({label: this.translate.instant('LANG_LOC_address'), value: 'address'});
      this.searchIDs.push({label: this.translate.instant('LANG_LOC_latitude'), value: 'latitude'});
      this.searchIDs.push({label: this.translate.instant('LANG_LOC_longitude'), value: 'longitude'});
      this.searchIDs.push({label: 'Cell Id', value: 'cellId'});
      this.getLocationList(1,10, '','','');
    } else if(this.activeTabNumber == 1) {
      this.searchIDs = [];
      this.searchIDs.push({label: '---------------', value: 'all'});
      this.searchIDs.push({label: this.translate.instant('LANG_GPS_Name'), value: 'name'});
      this.searchIDs.push({label: this.translate.instant('LANG_Around_Address'), value: 'address'});
      this.searchIDs.push({label: this.translate.instant('LANG_GPS_description'), value: 'description'});

      this.getGpsList(1,10, '','','');
    } else if(this.activeTabNumber == 2) {
      this.searchIDs = [];
      this.searchIDs.push({label: '---------------', value: 'all'});
      this.searchIDs.push({label: this.translate.instant('APName'), value: 'name'});
      this.searchIDs.push({label: 'BSID', value: 'bsID'});
      this.searchIDs.push({label: 'SSID', value: 'ssID'});
      this.getApList(1,10, '','','');
    } else if(this.activeTabNumber == 3) {
      this.searchIDs = [];
      this.searchIDs.push({label: '---------------', value: 'all'});
      this.searchIDs.push({label: this.translate.instant('LANG_BeaconName'), value: 'name'});
      this.searchIDs.push({label: this.translate.instant('LANG_BeaconProximityUUID'), value: 'proximityUUID'});
      this.searchIDs.push({label: this.translate.instant('AUDIT_BeaconAreaService_description'), value: 'description'});
      this.getBeaconList(1,10, '','','');
    }

  }

  getLocationList(page:number, max:number, search:string, like:string, field:string) {
    this.service.getLocationList(page, max, search, like, field).subscribe(
        value => {
          this.location_list = value.rows;
          this.logger.debug("-- location_list :", value);
        },
        error => { this.logger.error("-- error : " + error);},
        ()    => {}
      )
  }

  getBeaconList(page:number, max:number, search:string, like:string, field:string) {
    this.service.getBeaconList(page, max, search, like, field).subscribe(
        value => {
          this.control_beancon_list = value.rows;
          this.logger.debug("-- control_beancon_list :", value);
        },
        error => { this.logger.error("-- error : " + error);},
        ()    => {}
      )
  }

  getApList(page:number, max:number, search:string, like:string, field:string) {
    this.service.getApList(page, max, search, like, field).subscribe(
        value => {
          this.control_ap_list = value.rows;
          this.logger.debug("-- control_ap_list :", value);
        },
        error => { this.logger.error("-- error : " + error);},
        ()    => {}
      )
  }

  getGpsList(page:number, max:number, search:string, like:string, field:string) {
    this.service.getGpsList(page, max, search, like, field).subscribe(
        value => {
          this.control_gps_list = value.rows;
          this.logger.debug("-- control_gps_list :", value);
        },
        error => { this.logger.error("-- error : " + error);},
        ()    => {}
      )
  }

  getCompanyList():void{
      let url_path = "/mgr/system/company";
      this.service.get(url_path,null,null).subscribe(
          value => {
              this.company_list = value.content;
              this.logger.debug("-- company_list : " , value);
          },
          error=>{
              this.logger.error("-- error : " + error);
          },
          ()=>{
              this.logger.info("-- complate : ");
              if(this.company_list.length > 0) {
                this.company_item = [];
                this.company_list.forEach(company => {
                    this.company_item.push({label: company.name,  value: company});
                });
              }
              this.selectedCompany = this.company_list[0];

          }
      )
  }

  insertBeacon(beacon :any) {
      this.service.insertBeacon(beacon).subscribe(
          value => {
            this.beacon_ = value;
            this.logger.debug("-- beacon_ :", value);
          },
          error => { this.logger.error("-- error : " + error);},
          () => {
            this.getPolicyResourceRefresh();
            this.beacon_add_dlg_show = false;
          }
        )
  }

  insertLocation(location : any) {
      this.service.insertLocation(location).subscribe(
          value => {
            this.location_ = value;
            this.logger.debug("-- location_ :", value);
          },
          error => { this.logger.error("-- error : " + error);},
          () => {
            this.getPolicyResourceRefresh();
            this.location_add_dlg_show = false;
            this.location_show = false;
          }
        )
  }

  insertAp(ap : any) {
      this.service.insertAP(ap).subscribe(
          value => {
            var result = value;
            this.logger.debug("-- ap_ :", result);
          },
          error => { this.logger.error("-- error : " + error);},
          () => {
            this.getPolicyResourceRefresh();
          }
        )
  }

  insertGPS(gps : any) {
      this.service.insertGps(gps).subscribe(
          value => {
            var result = value;
            this.logger.debug("-- gps_ :", result);
          },
          error => { this.logger.error("-- error : " + error);},
          () => {
            this.getPolicyResourceRefresh();
            this.create_gps = "";
            this.gps_add_dlg_show = false;
            this.gmap_show = false;
          }
      )
  }

  updateGPS(gps : any) {
      this.service.updateGPS(gps).subscribe(
          value => {
            var result = value;
            this.logger.debug("-- gps_ :", result);
          },
          error => { this.logger.error("-- error : " + error);},
          () => {
            this.getPolicyResourceRefresh();
            this.create_gps = "";
            this.gps_add_dlg_show = false;
            this.gmap_show = false;
          }
      )
  }

  deleteLocation(ids:string){
    this.service.deleteLocation(ids).subscribe(
        value => {
          let returnValue = value;
          this.logger.debug("-- deleteLocation returnValue :", value);
        },
        error => { this.logger.error("-- error : " + error);},
        () => {
          this.getPolicyResourceRefresh();
        }
    )
  }

  deleteAp(ids:string){
    this.service.deleteAp(ids).subscribe(
        value => {
          let returnValue = value;
          this.logger.debug("-- deleteAp returnValue :", value);
        },
        error => { this.logger.error("-- error : " + error);},
        () => {
          this.getPolicyResourceRefresh();
        }
    )

  }

  deleteGps(ids:string) {
    this.service.deleteGps(ids).subscribe(
        value => {
          let returnValue = value;
          this.logger.debug("-- deleteGPS returnValue :", value);
        },
        error => { this.logger.error("-- error : " + error);},
        () => {
          this.getPolicyResourceRefresh();
        }
    )
  }

  deleteBeacon(ids:string){
    this.service.deleteBeacon(ids).subscribe(
        value => {
          let returnValue = value;
          this.logger.debug("-- deleteBeacon returnValue :", value);
        },
        error => { this.logger.error("-- error : " + error);},
        () => {
          this.getPolicyResourceRefresh();
        }
    )

  }

  getPolicyResourceRefresh() {
    switch(this.activeTabNumber){
      case 0:
        this.getLocationList(1, 10, '','','');
        break;
      case 1:
        this.getGpsList(1, 10, '','','');
        break;
      case 2:
        this.getApList(1, 10, '','','');
        break;
      case 3:
        this.getBeaconList(1, 10, '','','');
        break;
    }
  }

  add_location(event) {
    this.logger.debug("add_loacion");
    this.location_add_dlg_show = true;
    this.location_show = true;
    this.location_show_type = "location";
    this.title = this.translate.instant('LANG_LocationManagement') +" "+this.translate.instant('BUTTON_ADD');
    this.dialogWidth = 800;
    this.location_cellId="";
    this.location_name = "";
    this.location_description ="";
    this.location_address = "";
    this.location_latitude = "";
    this.location_longitude = "";
    this.getCompanyList();
  }
  add_beacon(event) {
    this.beacon_add_dlg_show = true;
    this.gmap_show = false;
    this.title = this.translate.instant('LANG_Beacon')+" "+ this.translate.instant('BUTTON_ADD');;
    this.beacon_name = "";
    this.beacon_uuid = "";
    this.beacon_minor = 0;
    this.beacon_major = 0;
    this.getCompanyList();
  }

  add_gps(event) {
    this.gps_add_dlg_show = true;
    this.gmap_show = true;
    this.gps_show_type = "add";
    this.title = "gps "+ this.translate.instant('BUTTON_ADD');
    this.gps_name = "";
    this.gps_desc = "";
    this.overlays = [];
  }

  add_ap(event) {
    this.ap_add_dlg_show = true;
    this.gmap_show = false;
    this.ap_name="";
    this.ap_desc = "";
    this.ap_bsid ="";
    this.ap_ssid = "";
    this.ap_auth = "";
    this.ap_pin = "";
    this.getCompanyList();
    /*this.bsidMask.defs['a']='[A-Fa-f0-5]';
    console.log("dlg_show", this.bsidMask.defs);*/


    this.title = "ap-wifi "+ this.translate.instant('BUTTON_ADD');
  }

  add_beacon_action(event) {
    let beacon = { id : null, name : this.beacon_name, area : this.beacon_description, major : this.beacon_major,
      minor : this.beacon_minor, proximityUUID : this.beacon_uuid, company : this.selectedCompany
    }
    this.insertBeacon(beacon);
  }

  add_location_action(event) {
      this.logger.debug("add_location_action");
      let location = { id:null, name : this.location_name, description : this.location_description,
      address : this.location_address, latitude : this.location_latitude, longitude : this.location_longitude,
      cellId : this.location_cellId, company : this.selectedCompany };
      this.insertLocation(location);
  }

  add_gps_action(event) {
    this.logger.debug("event :", event);
    this.logger.debug("create gps :", this.create_gps);
    if(this.gps_show_type == "add" && !this.create_gps) {
      alert(this.translate.instant('MESSAGE_GPS_ADD_SAVE'));
      return;
    }
    try {
      let t_gps = this.create_gps.split("|");
      if(t_gps.length <= 2) {
        alert(this.translate.instant('MESSAGE_GPS_3More_ADD'));
        return;
      }
    } catch(e) {
      this.logger.debug(e);
      alert(this.translate.instant('MESSAGE_GPS_ADD_Fail'));
      return;
    }

    let gps = { id : null, name : this.gps_name, address : this.gps_address, description :  this.gps_desc,
      locationGPS : this.create_gps, company : this.selectedCompany };
    if(this.gps_show_type == 'detail') {
      gps.id = this.gps_id;
      this.updateGPS(gps);

    } else {
      this.insertGPS(gps);
    }


    this.create_gps = "";
  }

  add_ap_action(event) {
    let ap = { id : null, name : this.ap_name, apDesc : this.ap_desc, bsID : this.ap_bsid, ssID : this.ap_ssid, auth : this.ap_auth,
      pin : this.ap_pin, company : this.selectedCompany };
    this.insertAp(ap);
    this.ap_add_dlg_show = false;
  }

  delete_location_action(event) {
    this.logger.debug("selectLocations",this.selectLocations);
    let i = [];
    if(this.selectLocations && this.selectLocations.length>0){
      this.selectLocations.forEach(item => {
        i.push(item.id);
      })
    }
    this.deleteLocation(i.join(","));

  }

  delete_ap_action(event) {
    let i = [];
    if(this.selectAps && this.selectAps.length>0){
      this.selectAps.forEach(item => {
        i.push(item.id);
      })
    }
    this.deleteAp(i.join(","));
  }

  delete_beacon_action(event) {
    let i = [];
    if(this.selectBeacons && this.selectBeacons.length>0){
      this.selectBeacons.forEach(item => {
        i.push(item.id);
      })
    }
    this.deleteBeacon(i.join(","));
  }

  delete_gps_action(event){
    this.logger.debug("gps 삭제");
    let i = [];
    if(this.selectGpses && this.selectGpses.length>0){
      this.selectGpses.forEach(item => {
        i.push(item.id);
      })
    }
    this.deleteGps(i.join(","));

  }


  rowClick(event) {
    this.logger.debug("rowClick : ", event);
  }
  onSubmit(event) {
    //this.gmap_show = false;
    this.logger.debug("submit :", event);

  }

  onlyNumber(event){
    this.logger.debug(event);
    if(event.keyCode < 45 || event.keyCode > 57) event.returnValue = false;
  }

  escCheck(event) {
    if(event.key == "Escape") event.returnValue = false;
  }

  confirm(event){
    this.gmap_show = false;
    this.location_show = false;
    this.location_add_dlg_show = false;
    this.beacon_add_dlg_show = false;
  }

  cancel(event) {
    this.gmap_show = false;
    this.location_show = false;
    this.location_add_dlg_show = false;
  }

  setCreateGps(event) {
    this.logger.debug("setCreateGps :" , event);
    this.create_gps = event;
  }

  setLocationInfo(event) {
    this.logger.debug("setLocationInfo event :", event)
    this.location_address = event.address;
    this.location_latitude = event.lat;
    this.location_longitude = event.lng;

  }

  selectDetailGps(gps) {
    this.logger.debug(gps);
    this.gps_id = gps.id;
    this.gps_add_dlg_show = true;
    this.overlays = [];
    this.selectGps = gps;
    this.gps_show_type = "detail";
    this.gmap_show = true;
    this.gps_name = gps.name;
    this.gps_desc = gps.description;
    this.selectedCompany = gps.company;
  }

  bsidPattern(event){
    var regex = new RegExp('[a-fA-F0-9]');
    if(regex.test(event.key)){
      var content1 = this.ap_bsid.replace(/\:/g, '');
      if((content1.length % 2)==0 && content1.length < 12 && content1.length>1){
        this.ap_bsid += ":";
      }
      return true;
    }else{
      event.returnValues = false;
      return false;
    }
  }


}

@NgModule({
  imports: [CustomGMapModule, InputTextModule, ExDialogModule, TabViewModule, PanelModule, DataTableModule, SharedModule, CommonModule, ButtonModule, LocationDialogModule, FormsModule,SearchModule,PaginatorModule, DropdownModule, GMapModule, InputMaskModule, MainPipeMoudle, TranslatePipeMoudle],
  exports: [PolicyResourceComponent],
  declarations: [PolicyResourceComponent],
  providers: [MamAdminService],
})
export class PolicyResourceModule {
}



// WEBPACK FOOTER //
// ./src/app/page/policy/policy_resource.ts